// extracted by mini-css-extract-plugin
export default {"loginForm":"loginPage_loginForm__cM0nc"};